export default {
    CashRespond: {
        respond_reject_message: 'Nakit yükleme işlemin iptal edildi',
        respond_success_message: 'Nakit yükleme işlemin başarıyla gerçekleşti',
        cancel_alert_title: 'Yüklemeyi İptal Et',
        cancel_alert_message:
            'Nakit yükleme işlemini iptal etmek istediğine emin misin?',
        alert_cancel_button: 'Vazgeç',
        alert_approve_button: 'Evet',
        action_button_cancel_title: 'İptal Et',
        action_button_respond_title: 'Onayla',
        respond_price_header_title: 'Yüklenecek Tutar',
        respond_price_header_description:
            'Lütfen nakit yükleme bilgilerine dikkat et',
    },
    MasterPassCardRegister: {
        route_header_title: 'Kart Ekle',
        content_header_title: 'Masterpass ile Kart Ekle',
        content_header_description:
            'Kart bilgilerin Masterpass güvencesi altında tutulmaktadır',
        form_label_card_number: 'Kart Numarası',
        form_label_expiry_date: 'Son Kullanma Tarihi',
        form_label_account_alias_name: 'Karta Bir İsim Ver',
        form_placeholder_expiry_date: 'AA/YY',
        form_placeholder_account_alias_name: 'Örn: Benim Kartım',
        form_agreement_checkbox_title:
            'Masterpass <0 href="https://www.masterpassturkiye.com/TermsAndConditions.aspx">Kullanıcı Sözleşmesi</0>‘ni okudum ve kartımı Masterpass altyapısında saklamak istiyorum',
        mp_user_agreement_url:
            'https://www.masterpassturkiye.com/TermsAndConditions.aspx',
        mp_user_agreement_header_title: 'Masterpass Kullanıcı Sözleşmesi',
        form_submit_button: 'Kartı Ekle',
    },
    MasterPassCards: {
        route_header_title: 'Masterpass Kartlarım',
        content_header_description:
            'İstediğin ödeme yöntemini seçili hale getirebilir, ödeme yöntemlerini düzenleyebilirsin',
        mp_delete_alert_title: 'Kartı Sil',
        mp_delete_alert_message:
            "Masterpass'e kayıtlı kartını\nsilmek istediğine emin misin?",
        mp_delete_alert_approve_button: 'Evet',
        mp_delete_alert_cancel_button: 'Vazgeç',
        register_card_row_item_title: 'Yeni Kart Ekle',
        delete_alert_button: 'Sil',
        card_change_alert_title: 'Yükleme Talimatın İptal Olacak',
        card_change_alert_message:
            '{{company}} cüzdanındaki yükleme talimatın bu karta bağlı. Kartını değiştirirsen talimat iptal edilir, yeni kartınla yeniden oluşturman gerekir.',
        card_change_alert_message_multiple:
            '{{count}} yükleme talimatın bu karta bağlı. Kartını değiştirirsen bu talimatlar iptal edilir, yeni kartınla yeniden oluşturman gerekir.',
        card_change_alert_approve_button: 'Devam Et',
        card_change_alert_cancel_button: 'Vazgeç',
        instruction_cancelled_toast_message:
            'Kart değişikliği nedeniyle yükleme talimatın iptal edildi. Bilgilerin korundu, yeni kartınla yeniden oluşturabilirsin.',
        mp_delete_alert_instruction_message:
            'Bu karta bağlı bir yükleme talimatın var.\nKartı silersen talimat da iptal edilir, devam etmek istiyor musun?',
    },
    MasterPassHelp: {
        route_header_title: 'Masterpass Destek',
        question_card_title: 'Kart sahibi siz misiniz?',
        question_card_description:
            'Eğer kart sahibinin kayıtlı cep numarası size ait değilse SMS size gönderilmez, kart sahibine gönderilir.',

        question_time_title: 'Kartın kullanım süresi doldu mu?',
        question_time_description:
            'Eklenen kartın geçerlilik süresi dolduysa giriş işlemleri sırasında tarafınıza SMS gelmeyebilir.',
        question_number_title: 'Kayıtlı numaranızı değiştirdiniz mi?',
        question_number_description:
            'Size ait olan bir kart, önceden farklı numara ile kaydedilmişse tarafınıza SMS gelmeyebilir.',
        question_do_what_title: 'Ne yapmalıyım?',
        question_do_what_description:
            "Tüm bu durumlar için Masterpass'in resmi sayfasından hesabınızla giriş yaparak kart bilgilerinizi güncelleyebilir, ardından Macellan SuperApp'te eşleştirmeyi yeniden deneyebilirsiniz.",
        action_button_help: 'Masterpass Desteğe Git',
    },
    MasterPassLink: {
        route_header_title: 'Kart Eşleştirme',
        info_sheet_title: 'Masterpass Kart Eşleştirme',
        info_sheet_description:
            'Daha hızlı yükleme yapabilmek için MasterPass hesabınızı bağlayabilirsin',
        info_sheet_question: 'Devam etmek istiyor musun?',
        info_sheet_approve_button: 'Kart Eşleştir',
        info_sheet_cancel_button: 'Vazgeç',
    },
    MasterPass3D: {
        error_message: '3D doğrulama işlemin başarısız oldu',
        timeout_alert_title: 'İşlem beklenenden uzun sürüyor',
        timeout_alert_message:
            'Bankadan sonuç henüz gelmedi. Bekleyebilir ya da cüzdana dönüp sonucu cüzdan hareketlerinden kontrol edebilirsin.',
        timeout_alert_approve_button: 'Cüzdana Dön',
        timeout_alert_cancel_button: 'Beklemeye Devam Et',
    },
    MasterPassOTP: {
        route_header_title: 'Masterpass Doğrulama',
        content_header_title: 'Masterpass Doğrulama',
        content_header_description: 'Telefonuna gelen 6 haneli kodu gir',
        resend_otp_toast_message: 'Doğrulama kodun yeniden gönderildi',
        success_type_link: 'Masterpass hesabın başarıyla eşleştirildi',
        success_type_register: 'Kart ekleme işlemin başarıyla gerçekleştirildi',
        resend_otp_button: 'Tekrar Gönder',
        help_button_text: 'Bir Sorun Mu Var ?',
        error_message: 'Ödeme işlemi başarısız oldu',
    },
    MasterPassInstructionOTP: {
        route_header_title: 'Masterpass Doğrulama',
        content_header_description: 'Telefonuna gelen 6 haneli kodu gir',
        resend_otp_toast_message: 'Doğrulama kodun yeniden gönderildi',
        resend_otp_button: 'Tekrar Gönder',
        help_button_text: 'Bir Sorun Mu Var ?',
        error_message: 'Talimat işlemin başarısız oldu',
        success_toast_message: 'Yükleme talimatı başarıyla oluşturuldu',
        success_update_toast_message: 'Yükleme talimatı başarıyla güncellendi',
    },
    TopUpInstruction: {
        route_header_title: 'Yükleme Talimatı',
        tab_title_instruction: 'Talimatım',
        tab_title_inactive: 'Geçmiş Talimatlarım',
        inactive_content_header_description:
            'İptal edilmiş, askıya alınmış veya süresi dolmuş talimatlarını burada görüntüleyebilirsin.',
        info_title: 'Yükleme talimatı nasıl çalışır?',
        info_description:
            'Bakiye ve puan toplamın belirlediğin tutarın altına düştüğünde, cüzdanın kayıtlı Masterpass kartından bu tutara otomatik olarak tamamlanır.',
        instruction_target_balance_section_title: 'HEDEF CÜZDAN BAKİYESİ',
        instruction_target_balance_section_description:
            'Bakiyeniz bu tutarın altına düştüğünde, cüzdanınız bu tutara tamamlanır.',
        instruction_date_section_title: 'GEÇERLİLİK TARİHİ',
        deposit_method_section_title: 'ÖDEME YÖNTEMİ',
        form_date_picker_placeholder: 'Tarih Seçiniz',
        footer_submit_button: 'Talimatı Oluştur',
        footer_update_button: 'Talimatı Güncelle',
        footer_cancel_button: 'Talimatı İptal Et',
        date_min_today: 'Geçerlilik tarihi bugünden önce olamaz',
        date_min_tomorrow: 'Geçerlilik tarihi en erken yarın olabilir',
        status_pending: 'Bekliyor',
        status_active: 'Aktif',
        status_suspended: 'Askıya Alındı',
        status_cancelled: 'İptal Edildi',
        status_expired: 'Süresi Doldu',
        empty_sheet_title: 'Henüz hiçbir talimatın yok.',
        empty_sheet_description:
            'İptal edilen, askıya alınan veya süresi dolan talimatların bu bölümde listelenir.',
        detail_sheet_title: 'Talimat Bilgileri',
        detail_sheet_description:
            'Bu talimat artık aktif değil. Detaylarını aşağıdan inceleyebilirsin.',
        detail_section_title: 'TALİMAT BİLGİLERİ',
        detail_target_balance_title: 'Hedef Cüzdan Bakiyesi',
        detail_end_date_title: 'Geçerlilik Tarihi',
        detail_card_title: 'Kart',
        detail_total_loaded_title: 'Toplam Yüklenen',
        detail_last_load_title: 'Son Yükleme',
        instruction_cancellation_title: 'İPTAL BİLGİLERİ',
        instruction_cancellation_reason_title: 'İptal Nedeni',
        instruction_cancellation_date_title:
            'Bu yükleme talimatı {{canceledDate}} tarihinde iptal edildi.',
        instruction_expired_title:
            'Bu yükleme talimatının {{expiredDate}} tarihinde süresi doldu.',
        alert_title: 'Talimatı Düzenle',
        alert_description:
            'Talimatını yeniden aktifleştirebilir veya iptal edebilirsin.',
        alert_activate_title: 'Talimatı Aktifleştir',
        alert_activate_description:
            'Talimatı aktifleştirmek istediğine emin misin?',
        alert_deactivate_title: 'Talimatı İptal Et',
        alert_deactivate_description:
            'Talimatı iptal etmek istediğine emin misin?',
        alert_activate_button: 'Talimatı Aktifleştir',
        alert_deactivate_button: 'Talimatı İptal Et',
        alert_reject_button: 'Vazgeç',
        success_activate_toast_message:
            'Yükleme talimatı başarıyla aktifleştirildi',
        success_cancel_toast_message: 'Yükleme talimatı başarıyla iptal edildi',
    },
    TopUp: {
        route_header_title: 'Bakiye Yükle',
        amount_section_title: 'YÜKLENECEK BAKİYE',
        deposit_chips_other_label: 'Farklı Tutar',
        payment_method_section_title: 'ÖDEME YÖNTEMİ',
        toast_success_message: 'Yükleme işlemin başarıyla gerçekleştirildi',
        footer_balance_title: 'YÜKLENECEK BAKİYE',
        footer_submit_button: 'Bakiye Yükle',
        other_payment_method_section_title: 'DİĞER ÖDEME YÖNTEMLERİ',
        other_deposit_method_deposit_card_title: 'Kart Numarası Girerek Yükle',
        other_payment_method_deposit_card_title: 'Kart Numarası Girerek Öde',
        other_deposit_method_cash_deposit_card_title: 'Nakit Yükleme',
        empty_deposit_method_title: 'İşlem Bilgisi',
        empty_deposit_method_description:
            'Bu markaya çok yakında bakiye yükleme yapılabileceksin',
        empty_deposit_method_question:
            'Dilersen kupon ekleyerek harcama yapabilirsin',
        balance: 'Bakiye',
        info_title: 'Bakiye yüklemede kazançlarım nelerdir?',
        info_description:
            'Bakiye yüklediğinizde cüzdandaki kampanyalara göre puan kazanırsınız.',
        installment_section_title: 'TAKSİT SEÇENEKLERİ',
        installment_section_more_button_title:
            'Tüm Taksit Seçenekleri ({{count}})',
        installment_section_hide_button_title: 'Gizle',
        installment_section_single_payment_title: 'Tek Çekim',
        installment_section_other_title:
            '{{installmentCount}} Taksit x {{formattedInstallmentAmount}}',
        empty_deposit_method_coupon_button: 'Kupon Ekle',
        custom_amount_validation:
            'Lütfen {{min}} ile {{max}} arasında bir değer girin',
    },
    EarnablePoint: {
        point_title: 'Kazanacağın hediye puan',
        point_label: 'Puan',
        up_has_toast_message:
            '<0>{{formattedIncreaseAmount}}</0> daha fazla yükle,\n<0>{{formattedHasPoint}} puan</0> kazan!',
        up_has_toast_chip: 'Hemen Ekle',
    },
    MasterPassDepositCard: {
        register_description: 'Masterpass ile Kart Ekle',
        link_description: 'Masterpass ile Kart Eşleştir',
        edit_button: 'Düzenle',
    },
    TopUpDepositCard: {
        change_button: 'Değiştir',
    },
    TopUpAnotherCard: {
        content_header_title: 'Kart Numarası Girerek Yükle',
        content_header_description:
            'Kart bilgilerin Masterpass güvencesi altında tutulmaktadır',
        form_label_credit_card_no: 'Kart Numarası',
        form_label_expire_date: 'Son Kullanma Tarihi',
        form_label_cvc_no: 'Güvenlik Kodu',
        form_placeholder_expire_date: 'AA/YY',
        form_placeholder_cvc_no: 'CVC/CVV',
        form_label_name: 'Karta Bir İsim Ver',
        form_placeholder_name: 'Örn: Benim Kartım',
        form_save_card_title: 'Sonraki yüklemeler için bu kartı kaydet',
        form_submit_button: 'Bakiye Yükle',
        form_agreement_checkbox_title:
            'Masterpass <0 href="https://www.masterpassturkiye.com/TermsAndConditions.aspx">Kullanıcı Sözleşmesi</0>‘ni okudum ve kartımı Masterpass altyapısında saklamak istiyorum',
        mp_user_agreement_url:
            'https://www.masterpassturkiye.com/TermsAndConditions.aspx',
        mp_user_agreement_header_title: 'Masterpass Kullanıcı Sözleşmesi',
        max_number_of_cards_error: 'En fazla 7 tane kart ekleyebilirsiniz.',
    },
    DepositRefund: {
        route_header_title: 'Yükleme İadesi',
        toast_error_message: 'Yükleme iadesi başarısız oldu',
    },
    DepositRefundSummary: {
        content_header_title: 'Yükleme İadesi Özeti',
        content_header_description:
            'İade işlemini onaylamadan önce özet bilgileri gözden geçirin.',
        detail_section_title: 'İADE BİLGİLERİ',
        detail_balance_to_be_deducted: 'Cüzdandan Düşecek Bakiye',
        detail_points_to_be_deducted: 'Geri Alınacak Puan',
        detail_earned_points_from_deposit: 'Yüklemeden Kazanılan Puan',
        detail_point_deducted_from_balance:
            'İade Anında Bakiyeden Düşülecek Puan',
        detail_net_amount_to_be_refunded_to_card:
            'Karta İade Edilecek Net Tutar',
        submit_button_text: 'Onayla',
        toast_success_message: 'Yükleme iadesi başarıyla gerçekleşti',
    },
    GoldFramer: {
        warning_message: 'Kartınızdan {{amount}} çekilecektir.',
    },
}
